import { RequestParams, sendRequest } from '.';
import { ICurrency, ICurrencyTransferResponse } from '../types/currency';

// search by code param
export const getCurrencyApi = (params: RequestParams) => {
  return sendRequest<ICurrency>({
    requestType: 'getCurrency',
    ...params,
  });
};

export const getCurrencyTransfersApi = (params: RequestParams, options: RequestInit = {}) => {
  return sendRequest<ICurrencyTransferResponse>(
    {
      requestType: 'getCurrencyTransfers',
      // currency: currencyInfo.currency,
      ...params,
    },
    options,
  ).then((res) => res.transfers);
};
